import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=352bca4d&scoped=true"
import script from "./ProjectEdit.vue?vue&type=script&lang=ts"
export * from "./ProjectEdit.vue?vue&type=script&lang=ts"
import style0 from "./ProjectEdit.vue?vue&type=style&index=0&id=352bca4d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352bca4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352bca4d')) {
      api.createRecord('352bca4d', component.options)
    } else {
      api.reload('352bca4d', component.options)
    }
    module.hot.accept("./ProjectEdit.vue?vue&type=template&id=352bca4d&scoped=true", function () {
      api.rerender('352bca4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ProjectEdit.vue"
export default component.exports